'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Forschungsprojekt = require('../entity').Forschungsprojekt;

module.exports = function (connection) {
  return {
    byRelevantFuerWeitereEquals: function byRelevantFuerWeitereEquals(relevantfuerweitere, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byRelevantFuerWeitereEquals', 'relevantfuerweitere')(relevantfuerweitere, additionalParams);
    },
    byTitelBeschreibungSpracheEquals: function byTitelBeschreibungSpracheEquals(titelbeschreibungsprache, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byTitelBeschreibungSpracheEquals', 'titelbeschreibungsprache')(titelbeschreibungsprache, additionalParams);
    },
    byTitelDELike: function byTitelDELike(titelde, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byTitelDELike', 'titelde')(titelde, additionalParams);
    },
    byFoerderungEquals: function byFoerderungEquals(foerderung, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byFoerderungEquals', 'foerderung')(foerderung, additionalParams);
    },
    byBeschreibungDELike: function byBeschreibungDELike(beschreibungde, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byBeschreibungDELike', 'beschreibungde')(beschreibungde, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byUebergeordnetesProjektLike: function byUebergeordnetesProjektLike(uebergeordnetesprojekt, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byUebergeordnetesProjektLike', 'uebergeordnetesprojekt')(uebergeordnetesprojekt, additionalParams);
    },
    byProjektBeginnEquals: function byProjektBeginnEquals(projektbeginn, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byProjektBeginnEquals', 'projektbeginn')(projektbeginn, additionalParams);
    },
    forForschungsbericht: function forForschungsbericht(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'forForschungsbericht', 'orgaid')(orgaid, additionalParams);
    },
    byProjektEndeEquals: function byProjektEndeEquals(projektende, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byProjektEndeEquals', 'projektende')(projektende, additionalParams);
    },
    byUebergeordnetesProjektEquals: function byUebergeordnetesProjektEquals(uebergeordnetesprojekt, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byUebergeordnetesProjektEquals', 'uebergeordnetesprojekt')(uebergeordnetesprojekt, additionalParams);
    },
    byAnyOrga: function byAnyOrga(orgaid, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byAnyOrga', 'orgaid')(orgaid, additionalParams);
    },
    byProjektLeiterEquals: function byProjektLeiterEquals(projektleiter, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byProjektLeiterEquals', 'projektleiter')(projektleiter, additionalParams);
    },
    byOrganisationseinheitEquals: function byOrganisationseinheitEquals(organisationseinheit, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byOrganisationseinheitEquals', 'organisationseinheit')(organisationseinheit, additionalParams);
    },
    byTitelENLike: function byTitelENLike(titelen, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byTitelENLike', 'titelen')(titelen, additionalParams);
    },
    byBeschreibungENLike: function byBeschreibungENLike(beschreibungen, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byBeschreibungENLike', 'beschreibungen')(beschreibungen, additionalParams);
    },
    byTitelDEEquals: function byTitelDEEquals(titelde, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byTitelDEEquals', 'titelde')(titelde, additionalParams);
    },
    findOne: function findOne(projection, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'findOne', 'projection')(projection, additionalParams);
    },
    findAll: function findAll(page, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'findAll', 'page')(page, additionalParams);
    },
    byBeschreibungENEquals: function byBeschreibungENEquals(beschreibungen, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byBeschreibungENEquals', 'beschreibungen')(beschreibungen, additionalParams);
    },
    byBeschreibungDEEquals: function byBeschreibungDEEquals(beschreibungde, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byBeschreibungDEEquals', 'beschreibungde')(beschreibungde, additionalParams);
    },
    byVerbundprojektEquals: function byVerbundprojektEquals(verbundprojekt, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byVerbundprojektEquals', 'verbundprojekt')(verbundprojekt, additionalParams);
    },
    byIstFinalEquals: function byIstFinalEquals(istfinal, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byIstFinalEquals', 'istfinal')(istfinal, additionalParams);
    },
    byTitelENEquals: function byTitelENEquals(titelen, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byTitelENEquals', 'titelen')(titelen, additionalParams);
    },
    byAntragstellerEquals: function byAntragstellerEquals(antragsteller, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byAntragstellerEquals', 'antragsteller')(antragsteller, additionalParams);
    },
    bySprecherhochschuleEquals: function bySprecherhochschuleEquals(sprecherhochschule, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'bySprecherhochschuleEquals', 'sprecherhochschule')(sprecherhochschule, additionalParams);
    },
    byWeitereOrganisationseinheitenEquals: function byWeitereOrganisationseinheitenEquals(weitereorganisationseinheiten, additionalParams) {
      return templates.searchTemplate(connection)(Forschungsprojekt, 'byWeitereOrganisationseinheitenEquals', 'weitereorganisationseinheiten')(weitereorganisationseinheiten, additionalParams);
    },
    byMultiValueSearchRep: function byMultiValueSearchRep(searchParams) {
      return templates.genericSearchTemplate(connection)(Forschungsprojekt, 'byMultiValueSearchRep')(searchParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Forschungsprojekt, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('forschungsprojekt')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/forschungsprojekt.js
// module id = TXvr
// module chunks = 0